import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Logo-MS_Horizontal-2.png'
import _imports_1 from '@/assets/iconite/home.png'
import _imports_2 from '@/assets/iconite/search.png'
import _imports_3 from '@/assets/menu_icons/Cereri_si_Oferte.png'
import _imports_4 from '@/assets/iconite/dorinte.png'
import _imports_5 from '@/assets/iconite/cos.png'


const _withScopeId = n => (_pushScopeId("data-v-95278136"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title__current__page" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  style: {"display":"flex","align-items":"center","min-width":"15rem"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"position":"relative","zoom":"0.75","margin-right":"4px","width":"24px","height":"24px"}
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"position":"relative","zoom":"0.75","margin-right":"4px","width":"24px","height":"24px"}
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  style: {"position":"relative","zoom":"0.8","margin-right":"4px"}
}, null, -1))
const _hoisted_7 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  style: {"position":"relative","zoom":"0.7","width":"28px","height":"24px","margin-right":"4px"}
}, null, -1))
const _hoisted_9 = { class: "app__label--medium" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  style: {"position":"relative","zoom":"0.75","width":"24px","height":"24px","margin-right":"4px"}
}, null, -1))
const _hoisted_11 = {
  key: 2,
  style: {"display":"flex","align-items":"center","max-height":"36px","min-height":"36px"},
  class: "q-px-sm"
}
const _hoisted_12 = {
  key: 3,
  style: {"display":"flex","align-items":"center","max-height":"36px","min-height":"36px"},
  class: "q-px-sm"
}
const _hoisted_13 = {
  key: 0,
  class: "app__color--label"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "row no-wrap q-pa-md" }
const _hoisted_16 = { class: "column items-center" }
const _hoisted_17 = { class: "text-h6 q-mb-md" }
const _hoisted_18 = { class: "app__color--label" }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row items-center no-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "text-center",
    style: {"padding":"10px"}
  }, [
    /*#__PURE__*/_createTextVNode(" imagine"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("profil ")
  ])
], -1))
const _hoisted_21 = { class: "text-h6" }
const _hoisted_22 = { class: "q-mt-md q-mb-xs" }
const _hoisted_23 = { class: "text-subtitle2" }
const _hoisted_24 = {
  key: 0,
  style: {"width":"100%","display":"flex","justify-content":"center","align-items":"center","position":"relative"}
}
const _hoisted_25 = {
  key: 1,
  class: "app__back__bar--title"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  style: {"position":"relative","zoom":"0.75","width":"24px","height":"24px","margin-right":"4px"}
}, null, -1))
const _hoisted_27 = {
  key: 4,
  style: {"margin-left":"auto","display":"flex"}
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  style: {"position":"relative","zoom":"0.75","width":"24px","height":"24px","margin-right":"4px"}
}, null, -1))
const _hoisted_29 = {
  key: 1,
  style: {"width":"100%","display":"flex"}
}
const _hoisted_30 = {
  key: 0,
  style: {"width":"100%","display":"flex","align-items":"center"}
}
const _hoisted_31 = {
  key: 0,
  style: {"display":"flex","align-items":"center","width":"100%"},
  class: "q-px-sm"
}
const _hoisted_32 = {
  key: 0,
  class: "app__color--label"
}
const _hoisted_33 = { style: {"min-width":"fit-content","text-align":"right","align-items":"center"} }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  style: {"position":"relative","zoom":"0.7","width":"28px","height":"24px","margin-right":"4px"}
}, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  style: {"position":"relative","zoom":"0.75","width":"24px","height":"24px","margin-right":"4px"}
}, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"center","align-items":"center","margin":"auto"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo-container",
    src: _imports_0,
    style: {"max-width":"188px","max-height":"51px"}
  })
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, "Document", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "span_pt_simulate_click" }, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " xxx ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_MenuApp = _resolveComponent("MenuApp")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _directive_close_popup = _resolveDirective("close-popup")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_q_layout, { view: "hHh lpR fFf" }, {
    default: _withCtx(() => [
      (_ctx.sessionIsValid)
        ? (_openBlock(), _createBlock(_component_q_header, {
            key: 0,
            bordered: "",
            style: {"background-color":"#FFFFFF","color":"black"}
          }, {
            default: _withCtx(() => [
              (_ctx.$q.platform.is.desktop)
                ? (_openBlock(), _createBlock(_component_q_toolbar, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_btn, {
                        dense: "",
                        flat: "",
                        round: "",
                        icon: "menu",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.leftDrawerOpen = !_ctx.leftDrawerOpen))
                      }),
                      _createElementVNode("img", {
                        class: "logo-container",
                        src: _imports_0,
                        style: {"cursor":"pointer","padding":"3px","max-width":"188px","max-height":"51px"},
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToDashboard && _ctx.goToDashboard(...args)))
                      }),
                      (_ctx.$q.screen.width > 1900)
                        ? (_openBlock(), _createBlock(_component_q_toolbar_title, {
                            key: 0,
                            class: "app__color--gray"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('message.portal')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_q_toolbar_title, { style: {"text-align":"center"} }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.currentPageTitle), 1)
                        ]),
                        _: 1
                      }),
                      (_ctx.userIsAuthenticated)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            (!_ctx.visibleInputFastSearch)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      "no-caps": "",
                                      onClick: _ctx.goToDashboard,
                                      style: {"color":"#273233","font-weight":"600 !important"}
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_4,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.main_page')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      "no-caps": "",
                                      onClick: _ctx.onGoCautaArticole,
                                      style: {"color":"#273233","font-weight":"600 !important"}
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_5,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.search_items')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      "no-caps": "",
                                      onClick: _ctx.onGoToOffers,
                                      style: {"color":"#273233","font-weight":"600 !important"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_icon, { style: {"cursor":"pointer"} }, {
                                          default: _withCtx(() => [
                                            _hoisted_6
                                          ]),
                                          _: 1
                                        }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.offers')) + " ", 1),
                                        (_ctx.userStore.countOferte>0)
                                          ? (_openBlock(), _createBlock(_component_q_badge, {
                                              key: 0,
                                              color: "red",
                                              class: "badge__superscript--top",
                                              style: {"height":"1rem","margin-left":"4px"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.userStore.countOferte), 1)
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["app__color--gray", { 'text-orange': _ctx.nrArticlesInFavorites>0}])
                                    }, null, 2)
                                  ]),
                                  _createVNode(_component_q_btn, {
                                    flat: "",
                                    "no-caps": "",
                                    onClick: _ctx.goToFavorite,
                                    style: {"color":"#273233","font-weight":"600 !important"}
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_8,
                                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('message.favorite')), 1),
                                      (_ctx.nrArticlesInFavorites>0)
                                        ? (_openBlock(), _createBlock(_component_q_badge, {
                                            key: 0,
                                            color: "red",
                                            floating: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.nrArticlesInFavorites), 1)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _createVNode(_component_q_btn, {
                                    flat: "",
                                    round: "",
                                    "no-caps": "",
                                    "text-color": "#9EADBA",
                                    ripple: { color: 'yellow' },
                                    class: "app__color--gray q-px-sm",
                                    onClick: _ctx.onGoTOMyShoppingCart,
                                    style: {"color":"#273233","font-weight":"600 !important"}
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_10,
                                      _createTextVNode(_toDisplayString(_ctx.$t('message.my_basket')) + " ", 1),
                                      (_ctx.nrArticlesInBasket>0)
                                        ? (_openBlock(), _createBlock(_component_q_badge, {
                                            key: 0,
                                            color: "red",
                                            floating: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.nrArticlesInBasket), 1)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.userIsAuthenticated)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_component_q_select, {
                              outlined: "",
                              modelValue: _ctx.selectedLang,
                              "onUpdate:modelValue": [
                                _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedLang) = $event)),
                                _cache[3] || (_cache[3] = val => _ctx.changeLanguage(val))
                              ],
                              options: _ctx.languages,
                              "option-value": "id",
                              "option-label": "name",
                              class: "form__input",
                              "emit-value": "",
                              dense: "",
                              "map-options": ""
                            }, null, 8, ["modelValue", "options"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.userIsAuthenticated)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            (_ctx.userCompanies.length <= 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.user.companyName), 1))
                              : (_openBlock(), _createBlock(_component_q_select, {
                                  key: 1,
                                  outlined: "",
                                  style: {"width":"100%"},
                                  modelValue: _ctx.user.companyName,
                                  "onUpdate:modelValue": [
                                    _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.companyName) = $event)),
                                    _cache[5] || (_cache[5] = val => _ctx.changeCompanyUser(val))
                                  ],
                                  options: _ctx.filteredCompanies,
                                  label: _ctx.$t('message.company'),
                                  class: "form__input",
                                  "option-value": "cif",
                                  "option-label": "denumire",
                                  clearable: "",
                                  "use-input": "",
                                  "emit-value": "",
                                  "map-options": "",
                                  dense: "",
                                  "input-debounce": "500",
                                  onFilter: _ctx.filterCompanies
                                }, {
                                  option: _withCtx((scope) => [
                                    _createVNode(_component_q_item, _mergeProps(scope.itemProps, _toHandlers(scope.itemEvents)), {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_section, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_label, {
                                              innerHTML: scope.opt.denumire
                                            }, null, 8, ["innerHTML"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1040)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "options", "label", "onFilter"]))
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.userIsAuthenticated)
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 4,
                            flat: "",
                            class: "app__color--label",
                            "no-caps": "",
                            label: _ctx.user.firstName+' '+_ctx.user.lastName
                          }, {
                            default: _withCtx(() => [
                              (_ctx.MyImgProfileString64.length>10)
                                ? (_openBlock(), _createBlock(_component_q_avatar, {
                                    key: 0,
                                    size: "42px",
                                    style: {"margin-left":"4px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        src: _ctx.MyImgProfileString64,
                                        fit: "scale-down",
                                        ratio: "1"
                                      }, null, 8, _hoisted_14)
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_q_icon, {
                                    key: 1,
                                    name: "person"
                                  })),
                              _createVNode(_component_q_menu, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('message.profile')), 1),
                                        _withDirectives(_createVNode(_component_q_icon, {
                                          left: "",
                                          size: "15px",
                                          name: "edit",
                                          onClick: _ctx.goToMyProfile,
                                          class: "is_clickable",
                                          style: {"position":"relative","top":"-7px","left":"7px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_tooltip, {
                                              "transition-show": "scale",
                                              "transition-hide": "scale"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('message.click_edit_profile')), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]), [
                                          [_directive_close_popup]
                                        ])
                                      ]),
                                      (_ctx.MyImgProfileString64.length>10)
                                        ? _withDirectives((_openBlock(), _createBlock(_component_q_avatar, {
                                            key: 0,
                                            size: "72px",
                                            onClick: _ctx.goToMyProfile
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("img", { src: _ctx.MyImgProfileString64 }, null, 8, _hoisted_19)
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"])), [
                                            [_directive_close_popup]
                                          ])
                                        : (_openBlock(), _createBlock(_component_q_btn, {
                                            key: 1,
                                            color: "#273233",
                                            unelevated: "",
                                            round: "",
                                            size: "lg",
                                            "no-caps": "",
                                            onClick: _ctx.goToMyProfile
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_20
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"])),
                                      _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1),
                                      _createElementVNode("div", _hoisted_22, [
                                        _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.user.emailAddress), 1)
                                      ]),
                                      _withDirectives(_createVNode(_component_q_btn, {
                                        style: {"margin-top":"auto"},
                                        color: "#273233",
                                        label: "Logout",
                                        outline: "",
                                        push: "",
                                        size: "sm",
                                        onClick: _ctx.logout
                                      }, null, 8, ["onClick"]), [
                                        [_directive_close_popup]
                                      ])
                                    ])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["label"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$q.platform.is.mobile)
                ? (_openBlock(), _createBlock(_component_q_toolbar, { key: 1 }, {
                    default: _withCtx(() => [
                      (_ctx.showBackBar)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            (!_ctx.visibleMobileBarForSearch)
                              ? (_openBlock(), _createBlock(_component_q_icon, {
                                  key: 0,
                                  name: "arrow_back_ios",
                                  onClick: _ctx.goBack,
                                  class: "app__arrow--back"
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (!_ctx.visibleMobileBarForSearch)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.titleBackBar), 1))
                              : _createCommentVNode("", true),
                            (_ctx.showAddBtnBarMenu)
                              ? (_openBlock(), _createBlock(_component_q_btn, {
                                  key: 2,
                                  square: "",
                                  icon: "add",
                                  style: {"margin-left":"auto","height":"2rem","width":"2rem","background-color":"#9b7d32","color":"white"},
                                  onClick: _ctx.onClickAddBtnForDialogChild
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.showBasketBtnBarMenu && !_ctx.visibleMobileRightBtnForDashboard)
                              ? (_openBlock(), _createBlock(_component_q_btn, {
                                  key: 3,
                                  flat: "",
                                  square: "",
                                  color: "#273233",
                                  "text-color": "#9EADBA",
                                  class: "app__color--label",
                                  style: {"margin-left":"auto","height":"2rem","width":"2rem"},
                                  onClick: _ctx.onGoTOMyShoppingCart
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_26,
                                    _createVNode(_component_q_badge, {
                                      color: "red-3",
                                      floating: "",
                                      transparent: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.nrArticlesInBasket), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.visibleMobileRightBtnForDashboard && !_ctx.visibleMobileBarForSearch)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  (_ctx.showBasketBtnBarMenu)
                                    ? (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 0,
                                        flat: "",
                                        square: "",
                                        color: "#273233",
                                        "text-color": "#9EADBA",
                                        class: "app__color--label",
                                        style: {"height":"2rem","width":"2rem"},
                                        onClick: _ctx.onGoTOMyShoppingCart
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_28,
                                          _createVNode(_component_q_badge, {
                                            color: "red-3",
                                            floating: "",
                                            transparent: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.nrArticlesInBasket), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.showMenuBar)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            (!_ctx.visibleInputFastSearch)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  _createVNode(_component_q_btn, {
                                    dense: "",
                                    flat: "",
                                    round: "",
                                    icon: "menu",
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.leftDrawerOpen = !_ctx.leftDrawerOpen))
                                  }),
                                  (_ctx.userIsAuthenticated)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                        (_ctx.userCompanies.length <= 1)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.user.companyName), 1))
                                          : (_openBlock(), _createBlock(_component_q_select, {
                                              key: 1,
                                              outlined: "",
                                              style: {"width":"100%"},
                                              modelValue: _ctx.user.companyName,
                                              "onUpdate:modelValue": [
                                                _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user.companyName) = $event)),
                                                _cache[8] || (_cache[8] = val => _ctx.changeCompanyUser(val))
                                              ],
                                              options: _ctx.filteredCompanies,
                                              ref: "refCompany",
                                              label: _ctx.$t('message.company'),
                                              class: "form__input",
                                              "option-value": "cif",
                                              "option-label": "denumire",
                                              clearable: "",
                                              "use-input": "",
                                              "emit-value": "",
                                              "map-options": "",
                                              "input-debounce": "500",
                                              onFilter: _ctx.filterCompanies
                                            }, {
                                              option: _withCtx((scope) => [
                                                _createVNode(_component_q_item, _mergeProps(scope.itemProps, _toHandlers(scope.itemEvents)), {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_q_item_section, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_q_item_label, {
                                                          innerHTML: scope.opt.cif
                                                        }, null, 8, ["innerHTML"])
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_q_item_section, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_q_item_label, {
                                                          innerHTML: scope.opt.name
                                                        }, null, 8, ["innerHTML"]),
                                                        _createVNode(_component_q_item_label, { caption: "" }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(scope.opt.code), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1040)
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue", "options", "label", "onFilter"]))
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_33, [
                                    (_ctx.nrArticlesInFavorites>0)
                                      ? (_openBlock(), _createBlock(_component_q_btn, {
                                          key: 0,
                                          flat: "",
                                          round: "",
                                          color: "#273233",
                                          "text-color": "#9EADBA",
                                          class: "app__color--label",
                                          onClick: _ctx.goToFavorite
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_34,
                                            _createVNode(_component_q_badge, {
                                              color: "red-3",
                                              floating: "",
                                              transparent: ""
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.nrArticlesInFavorites), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      round: "",
                                      color: "#273233",
                                      "text-color": "#9EADBA",
                                      class: "app__color--label",
                                      onClick: _ctx.onGoTOMyShoppingCart
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_35,
                                        _createVNode(_component_q_badge, {
                                          color: "red-3",
                                          floating: "",
                                          transparent: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.nrArticlesInBasket), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_drawer, {
        modelValue: _ctx.leftDrawerOpen,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.leftDrawerOpen) = $event)),
        side: "left",
        behavior: "mobile",
        overlay: "",
        elevated: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item, null, {
                default: _withCtx(() => [
                  _hoisted_36
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(_component_q_item, {
                clickable: "",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.leftDrawerOpen=false))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { avatar: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        color: "#273233",
                        name: "close"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('message.close')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_directive_ripple]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_MenuApp, {
            userid: _ctx.user.userid,
            onCloseMenu: _ctx.onCloseMenu
          }, null, 8, ["userid", "onCloseMenu"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_drawer, {
        modelValue: _ctx.rightDrawerOpen,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.rightDrawerOpen) = $event)),
        side: "right",
        behavior: "mobile",
        overlay: "",
        elevated: "",
        width: _ctx.widthForDrawerDocument
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_bar, { style: {"height":"50px"} }, {
            default: _withCtx(() => [
              _hoisted_37,
              _createVNode(_component_q_space),
              _hoisted_38,
              _createVNode(_component_q_btn, {
                size: "md",
                flat: "",
                icon: "close",
                onClick: _ctx.closeWindowDocument
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }),
          _hoisted_39
        ]),
        _: 1
      }, 8, ["modelValue", "width"]),
      _createVNode(_component_q_page_container, {
        style: {"min-height":"calc(100vh - 52px)"},
        class: _normalizeClass(_ctx.$route.name === 'Login' ? 'login-bg' : 'default-bg')
      }, {
        default: _withCtx(() => [
          (_ctx.isLoadingNomenclatoare)
            ? (_openBlock(), _createBlock(_component_q_banner, {
                key: 0,
                "inline-actions": "",
                class: "text-white bg-red"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.mesajSeLoadingNomenclatoare), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_KeepAlive, null, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                  ], 1024))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}